export default{
    namespaced: true,

    state:{
        //loadingBorra:false,
    },

    mutations:{
        //ABRE_VENTANA_LOGIN(state, d){
        //    state.ventanaLogin = d
        //},
    },

    actions:{
        /**
         * Borra el contenido de una entrada usando el dominio, el id y el motivo.
         * Los params vienen en un objeto llamado data
         *
         * @param {*} context               El context de este modulo
         *
         * @param {*} data                  Objeto que contiene:
         *                                  Number id: El id de la entrada a borrar
         *                                  String motivo: La descripción del motivo de esta eliminación
         *                                  String registro: El nombre del dominio a borrar en formato paquete.dominio
         *
         * @returns                         Si la eliminación fue exitosa, regresa:
         *                                  Boolean estado: true
         *                                  Object root: Los datos de la nueva entrada
         *
         *                                  Si existe un error de validación al momento de guardar, regresa
         *                                  Boolean estado: false
         *                                  Object root: vacio
         *
         *                                  Si existe un error que requiere mayor procesamiento, regresa
         *                                  Boolean estado: false
         *                                  Object root: Errores regresados por el backend
         */
        async borra_entrada(context, data){
            try{
                let req = await this.$http({
                    url:context.rootState.http.principal.borraEntrada,
                    method:'POST',
                    params:data,
                })
                if (!req.data.estado){
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'No se puede borrar',
                        text: 'Revise los datos e intente de nuevo.',
                    })
                }
                return {estado: req.data.estado, root:req.data.root}
            }catch(err){
                return ({estado:false, root:err})
            }
        },

        async cargaPersonal(context, data){
            try{
                const req = await this.$http({
                    url: context.rootState.http.principal.listaTrabjadoresCasf,
                    params:{
                        page:1,
                        query:data,
                        start:0,
                        limit:15,
                    },
                })
                return req.data.root

            }catch(err){
                return []
            }
        },
        //async cargaAntes(context, data){
        //    console.log(context)
        //}
    },

    getters:{
        //datosUsuario(state){
        //    return {username:state.username, roles:state.roles}
        //},
    }
}